// Traducciones al inglés: clave = texto en español exactamente como en el código.
// Portal de miembros, sitio público, chat, páginas y administración.
export default {
  // Portal: inicio
  'Hola, {name}': 'Hi, {name}',
  'Tienes {n} solicitud para servir sin responder.': 'You have {n} request to serve that needs a response.',
  'Tienes {n} solicitudes para servir sin responder.': 'You have {n} requests to serve that need a response.',
  'Responder': 'Respond',
  'Próximas veces que sirves': 'Upcoming times you serve',
  'Ver todo': 'See all',
  'Ver todos': 'See all',
  'No estás programado próximamente': 'You’re not scheduled anytime soon',
  'Pendiente': 'Pending',
  'Sin avisos': 'No notifications',
  'Mis grupos': 'My groups',
  'Buscar grupos': 'Find groups',
  'Aún no estás en un grupo': 'You’re not in a group yet',
  'Encuentra uno en “Grupos”.': 'Find one under “Groups.”',
  'Líder': 'Leader',
  'Inscripciones abiertas': 'Open registrations',
  'Mis inscripciones': 'My registrations',
  'Nada abierto por ahora': 'Nothing open right now',
  'Mi perfil y familia': 'My profile & family',
  'Contraseña y seguridad': 'Password & security',

  // Portal: programación
  'Periodo': 'Period',
  'Próximas': 'Upcoming',
  'Anteriores': 'Past',
  'Sin historial': 'No history',
  'Ensayo': 'Rehearsal',
  'Motivo: {reason}': 'Reason: {reason}',
  'Acepto': 'Accept',
  'No puedo': 'Can’t serve',
  'No puedo servir': 'Can’t serve',
  'Enviar': 'Submit',
  '¿Algún horario que NO puedas?': 'Any times you CAN’T make?',
  'Motivo (opcional)': 'Reason (optional)',
  'Motivo': 'Reason',
  'Fechas en que no puedo servir': 'Dates I can’t serve',
  '¿Quitar este bloqueo?': 'Remove this blockout?',
  'Avísanos cuándo estarás fuera para que no te programen.': 'Let us know when you’ll be away so you don’t get scheduled.',
  'Desde': 'From',
  'Hasta': 'To',

  // Portal: donar
  'Escribe un monto válido': 'Enter a valid amount',
  'Donación en línea': 'Give online',
  'Las donaciones en línea aún no están activadas. Puedes dar en efectivo o cheque en cualquier servicio; aparecerán aquí cuando se registren.': 'Online giving isn’t turned on yet. You can give cash or check at any service; your gifts will show up here once they’re recorded.',
  'Fondo': 'Fund',
  'Monto (USD)': 'Amount (USD)',
  'Cubrir la comisión de la tarjeta': 'Cover the card fee',
  'Continuar': 'Continue',
  'próximo {date}': 'next {date}',
  'Activa': 'Active',
  'Pausada': 'Paused',
  'Cancelada': 'Canceled',
  'Constancias para impuestos': 'Tax statements',
  'Constancia {year} (PDF) ↗': '{year} statement (PDF) ↗',
  'Aún no hay donaciones registradas.': 'No gifts recorded yet.',
  'Historial': 'History',
  'Sin donaciones': 'No gifts',
  'Reembolso {amount}': 'Refund {amount}',
  'Abriendo tu constancia…': 'Opening your statement…',

  // Portal: inscripciones
  'Confirmada': 'Confirmed',
  'Pago pendiente': 'Payment due',
  'Lista de espera': 'Waitlist',
  'Aún no te has inscrito a nada': 'You haven’t registered for anything yet',
  '(espera #{n})': '(waitlist #{n})',
  'Pagado {paid} de {total}': 'Paid {paid} of {total}',
  '¡Pago recibido!': 'Payment received!',
  'Pagar {amount}': 'Pay {amount}',
  '¿Cancelar esta inscripción?': 'Cancel this registration?',

  // Portal: grupos
  'Administrar': 'Manage',
  '¿Salir de {name}?': 'Leave {name}?',
  'Salir@@grupo': 'Leave',

  // Portal: perfil
  'Mis datos': 'My information',
  'Campus: {name}': 'Campus: {name}',
  'Cómo te gusta que te llamen': 'What you like to be called',
  'Fecha de nacimiento': 'Birthdate',
  'Género': 'Gender',
  'Estado civil': 'Marital status',
  'Datos guardados': 'Information saved',
  'Contacto': 'Contact',
  'Contacto guardado': 'Contact info saved',
  'Guardar contacto': 'Save contact info',
  'Mi familia': 'My family',
  'Si quieres registrar a tu familia (por ejemplo, para el check-in de niños), pide ayuda en la iglesia.': 'If you’d like to add your family (for example, for kids’ check-in), ask for help at church.',
  'Hijo/a': 'Child',
  'Adulto': 'Adult',
  'Preferencias guardadas': 'Preferences saved',
  '¿Cómo quieres que te avisemos?': 'How would you like us to notify you?',
  'Mensaje de texto (SMS)': 'Text message (SMS)',
  'Siempre verás los avisos en este portal.': 'You’ll always see notifications in this portal.',

  // Portal: avisos
  'Marcar todo como leído': 'Mark all as read',

  // Pago con tarjeta
  'No se pudo cargar Stripe. Revisa tu conexión.': 'Couldn’t load Stripe. Check your connection.',
  'El pago no se pudo completar': 'The payment couldn’t be completed',
  'El pago requiere otra verificación. Intenta de nuevo.': 'The payment needs additional verification. Please try again.',
  'Cargando pago seguro…': 'Loading secure payment…',

  // Sitio público
  'Sitio': 'Site',
  'Mi portal': 'My portal',
  'Bienvenidos a {name}': 'Welcome to {name}',
  'nuestra iglesia': 'our church',
  '{n} campus: {list}': '{n} campuses: {list}',
  'Servicios especiales, conferencias y actividades.': 'Special services, conferences and activities.',
  'Encuentra un grupo cerca de ti.': 'Find a group near you.',
  'Retiros, campamentos y cursos.': 'Retreats, camps and classes.',
  'Conócenos': 'About us',
  'No hay eventos públicos en los próximos dos meses': 'No public events in the next two months',
  'Todo el día': 'All day',
  '¡Ya eres parte del grupo!': 'You’re in the group!',
  'Solicitud enviada a los líderes.': 'Request sent to the leaders.',
  'No se pudo enviar': 'Couldn’t send',
  'Tipo': 'Type',
  'Todos los tipos': 'All types',
  'No hay grupos disponibles': 'No groups available',
  'Lleno': 'Full',
  'Ya eres miembro': 'You’re a member',
  'Solicitud enviada': 'Request sent',
  'No recibe nuevos miembros por ahora.': 'Not accepting new members right now.',
  'Unirme': 'Join',
  'Pedir unirme': 'Request to join',
  'Inicia sesión para unirte': 'Sign in to join',
  'No hay inscripciones abiertas en este momento': 'No open registrations right now',
  'Inscribirme': 'Register',
  'Cierra {date}': 'Closes {date}',
  '¡Inscripción recibida!': 'Registration received!',
  'Inscrito': 'Registered',
  'Total:': 'Total:',
  'Puedes pagar desde “Inscripciones” en tu portal.': 'You can pay from “Registrations” in your portal.',
  'La iglesia te indicará cómo pagar.': 'The church will let you know how to pay.',
  'Te enviamos una confirmación a {email}.': 'We sent a confirmation to {email}.',
  'Ver mis inscripciones': 'See my registrations',
  'Las inscripciones no están abiertas.': 'Registration isn’t open.',
  'Esta inscripción aún no está lista.': 'This registration isn’t ready yet.',
  'Queda {n} lugar.': '{n} spot left.',
  'Quedan {n} lugares.': '{n} spots left.',
  'Cupo lleno: te anotaremos en la lista de espera.': 'It’s full: we’ll add you to the waitlist.',
  'Cupo lleno.': 'It’s full.',
  'Quién inscribe': 'Who’s registering',
  'Nombre completo': 'Full name',
  'Asistentes': 'Attendees',
  'Agregar de mi familia:': 'Add from my family:',
  'gratis': 'free',
  'lleno': 'full',
  '+ Agregar asistente': '+ Add attendee',
  'Enviar inscripción': 'Submit registration',
  '¡Gracias!': 'Thank you!',
  'Recibimos tu información. Alguien de la iglesia se pondrá en contacto contigo.': 'We received your information. Someone from the church will be in touch.',
  'Nombre *': 'First name *',
  'Apellido *': 'Last name *',
  'Correo *': 'Email *',

  // Chat
  '+ Nueva conversación': '+ New conversation',
  '+ Nueva': '+ New',
  'Sin conversaciones': 'No conversations',
  'Conversación': 'Conversation',
  'Grupo': 'Group',
  'Equipo': 'Team',
  'Sin mensajes': 'No messages',
  'Elige una conversación': 'Choose a conversation',
  'Escribe el primer mensaje': 'Write the first message',
  'Mensaje borrado': 'Message deleted',
  'borrar': 'delete',
  'Escribe un mensaje…': 'Write a message…',
  'Mensaje': 'Message',
  'Enviar@@mensaje': 'Send',
  'Nueva conversación': 'New conversation',
  'Con': 'With',
  'Una persona': 'One person',
  'Mi grupo (soy líder)': 'My group (I’m the leader)',
  'Elige…': 'Choose…',
  'Crear chat del grupo': 'Create group chat',
  'No eres líder de ningún grupo.': 'You don’t lead any groups.',

  // Páginas
  'Página guardada': 'Page saved',
  'Contenido para el portal de miembros y el sitio público (quiénes somos, horarios, cómo llegar…).': 'Content for the member portal and the public site (about us, service times, directions…).',
  '+ Nueva página': '+ New page',
  'Sin páginas': 'No pages',
  'Publicada': 'Published',
  'Borrador': 'Draft',
  'actualizada {date}': 'updated {date}',
  'Ver ↗': 'View ↗',
  '¿Eliminar la página “{title}”?': 'Delete the page “{title}”?',
  'Editar página': 'Edit page',
  'Nueva página': 'New page',
  'Vista previa': 'Preview',
  'Título': 'Title',
  'Dirección (slug)': 'Address (slug)',
  'Contenido': 'Content',
  '# Título, ## Subtítulo, **negrita**, *cursiva*, - listas, [enlace](https://…). No se permite HTML.': '# Title, ## Subtitle, **bold**, *italic*, - lists, [link](https://…). HTML isn’t allowed.',

  // Administración: personal y permisos
  'Ver': 'View',
  'Personal y permisos': 'Staff & permissions',
  'Organización': 'Organization',
  'Mensajes salientes': 'Outbox',
  'Bitácora': 'Audit log',
  'Cada permiso es por módulo y nivel, para todos los campus o para uno en particular.': 'Each permission is per module and level, for all campuses or for one in particular.',
  '+ Dar acceso a una persona': '+ Give a person access',
  'Buscar por nombre o correo': 'Search by name or email',
  'Sin cuentas': 'No accounts',
  'Desactivada': 'Deactivated',
  'último acceso {date}': 'last sign-in {date}',
  'nunca ha entrado': 'never signed in',
  'Quitar permiso': 'Remove permission',
  'Sin permisos de personal (solo portal).': 'No staff permissions (portal only).',
  '+ Permiso': '+ Permission',
  '{name} ya no podrá iniciar sesión.': '{name} will no longer be able to sign in.',
  'Desactivar@@cuenta': 'Deactivate',
  'Reactivar': 'Reactivate',
  'Quitar privilegios de administrador general.': 'Remove super admin privileges.',
  'Tendrá acceso total a todos los módulos y campus.': 'They’ll have full access to all modules and campuses.',
  'Quitar admin': 'Remove admin',
  'Hacer admin': 'Make admin',
  'Dar acceso a una persona': 'Give a person access',
  'Cuenta creada para {name}.': 'Account created for {name}.',
  'Contraseña temporal (cópiala ahora; no se volverá a mostrar):': 'Temporary password (copy it now; it won’t be shown again):',
  'Pídele que la cambie en “Mi cuenta” al entrar. Después asígnale permisos con “+ Permiso”.': 'Ask them to change it in “My account” when they sign in. Then give them permissions with “+ Permission.”',
  'Persona (debe existir en Personas)': 'Person (must already exist in People)',
  'Correo para iniciar sesión': 'Sign-in email',
  'Se generará una contraseña temporal segura.': 'A secure temporary password will be generated.',
  'Permiso para {name}': 'Permission for {name}',
  'Módulo': 'Module',
  'Nivel': 'Level',
  'Ver: consulta. Editar: crea y modifica. Administrar: además configura el módulo y borra. Si ya tenía un permiso para ese módulo y campus, se reemplaza el nivel.': 'View: can look things up. Edit: can create and change. Manage: can also configure the module and delete. If they already had a permission for that module and campus, the level is replaced.',

  // Administración: campus y organización
  'Campus guardado': 'Campus saved',
  '+ Nuevo campus': '+ New campus',
  'Inactivo': 'Inactive',
  'Sin dirección': 'No address',
  'Editar campus': 'Edit campus',
  'Nuevo campus': 'New campus',
  'Nombre@@cosa': 'Name',
  'Código corto': 'Short code',
  'Se usa en importaciones y reportes': 'Used in imports and reports',
  'Calle': 'Street',
  'Ciudad': 'City',
  'Estado@@dirección': 'State',
  'Código postal': 'ZIP code',
  'Teléfono': 'Phone',
  'Activo': 'Active',
  'Zona horaria principal': 'Main time zone',
  'Moneda (ISO)': 'Currency (ISO)',
  'Idioma': 'Language',

  // Administración: mensajes salientes y bitácora
  'Correos, SMS, WhatsApp y notificaciones push que envía la plataforma.': 'Emails, SMS, WhatsApp messages and push notifications sent by the platform.',
  'Notificaciones push': 'Push notifications',
  'configurado': 'configured',
  'sin configurar': 'not configured',
  'Sin proveedor, los mensajes quedan registrados (“logged”) pero no se envían. Configura EMAIL_PROVIDER, EMAIL_API_KEY y EMAIL_FROM en el servidor.': 'Without a provider, messages are recorded (“logged”) but not sent. Set EMAIL_PROVIDER, EMAIL_API_KEY and EMAIL_FROM on the server.',
  'Fecha': 'Date',
  'Canal': 'Channel',
  'Para': 'To',
  'Asunto': 'Subject',
  'Estado': 'Status',
  'Registro de acciones sensibles: permisos, donaciones, check-out, fusiones, configuración.': 'Record of sensitive actions: permissions, donations, check-out, merges, settings.',
  'Todo': 'All',
  'Sin registros': 'No entries',
  'Quién': 'Who',
  'Acción': 'Action',
  'Detalle': 'Details',
  'kiosko/anónimo ({ip})': 'kiosk/anonymous ({ip})',
  'sistema': 'system',
  'Idioma de los mensajes': 'Language for messages',
  "Ya estaba programado: {list}. Responde “No puedo” en esas fechas para avisar al líder.": "Already scheduled: {list}. Answer “Can’t make it” on those dates to let the leader know.",
  "Fechas en que no podemos servir": "Dates we can’t serve",
  "De quién": "Whose",
  "Yo": "Me",
  "{name} no tiene fechas bloqueadas.": "{name} has no blocked dates.",
  "Para toda la familia (por ejemplo, un viaje)": "For the whole family (for example, a trip)",
  "Una vez": "One time",
  "Cuenta bancaria": "Bank account",
  "¡Gracias! Tu donación desde la cuenta bancaria está en proceso: el banco la confirma en unos días hábiles.": "Thank you! Your bank account gift is processing: the bank confirms it within a few business days.",
  "¡Gracias por tu generosidad! Tu donación ya está en tu historial.": "Thank you for your generosity! Your gift is already in your history.",
  "Estamos verificando tu cuenta bancaria. Te avisaremos por correo cuando tu donación recurrente esté activa.": "We’re verifying your bank account. We’ll email you when your recurring gift is active.",
  "Listo: tu donación recurrente usará el nuevo método de pago.": "Done: your recurring gift will use the new payment method.",
  "¡Gracias! Tu donación recurrente está activa. Te enviamos la confirmación por correo.": "Thank you! Your recurring gift is active. We sent you a confirmation email.",
  "Cubrir la comisión bancaria": "Cover the bank fee",
  "Ingresa la nueva tarjeta o cuenta. No se cobra nada ahora.": "Enter the new card or account. Nothing is charged now.",
  "Guardaremos tu método de pago en Stripe para cobrar {amount} {frequency}, a partir del {date}. Puedes cambiarla o cancelarla cuando quieras.": "We’ll save your payment method with Stripe to charge {amount} {frequency}, starting {date}. You can change or cancel it anytime.",
  "Guardar método de pago": "Save payment method",
  "Activar donación recurrente": "Start recurring gift",
  "Primer cobro": "First charge",
  "Método de pago": "Payment method",
  "Cuenta bancaria (ACH)": "Bank account (ACH)",
  "Con cuenta bancaria la comisión es mucho menor (0.8 %, máximo $5) y llega más a la iglesia. El banco confirma el pago en unos días hábiles.": "With a bank account the fee is much lower (0.8%, max $5), so more reaches the church. The bank confirms the payment within a few business days.",
  "{label} (total {total})": "{label} (total {total})",
  "cubre la comisión": "covers the fee",
  "Pausada porque no se pudo cobrar ({reason}). Cambia la tarjeta o cuenta para reanudarla.": "Paused because it couldn’t be charged ({reason}). Change the card or account to resume it.",
  "No se pudo cobrar ({reason}). Lo intentaremos de nuevo.": "Couldn’t be charged ({reason}). We’ll try again.",
  "Cambiar tarjeta o cuenta": "Change card or account",
  "Se cancelará la donación recurrente. No se harán más cobros.": "The recurring gift will be cancelled. No more charges will be made.",
  "Cancelar donación": "Cancel gift",
  "No se completó": "Not completed",
  "Cambiar donación recurrente": "Change recurring gift",
  "Próximo cobro": "Next charge",
  "Stripe enviará dos depósitos pequeños a tu cuenta en 1 a 2 días hábiles. Cuando lleguen, confirma los montos para completar tu donación; también te llegará un correo de Stripe con el enlace.": "Stripe will send two small deposits to your account within 1 to 2 business days. When they arrive, confirm the amounts to complete your gift; you’ll also get an email from Stripe with the link.",
  "Confirmar los depósitos": "Confirm the deposits",
  "Volver a recibir avisos de esta conversación en tus dispositivos": "Get notifications from this conversation on your devices again",
  "No recibir avisos de esta conversación en tus dispositivos": "Don’t get notifications from this conversation on your devices",
  "Silenciada": "Muted",
  "Silenciar": "Mute",
  "En el iPhone o iPad: abre esta página en Safari, toca Compartir (el cuadro con la flecha ↑) y luego «Agregar a inicio».": "On iPhone or iPad: open this page in Safari, tap Share (the square with the ↑ arrow), then “Add to Home Screen”.",
  "En el menú del navegador, elige «Instalar app» o «Agregar a la pantalla de inicio».": "In the browser menu, choose “Install app” or “Add to Home screen”.",
  "Este navegador no permite notificaciones.": "This browser doesn’t support notifications.",
  "La iglesia todavía no activó las notificaciones en el servidor.": "The church hasn’t turned on notifications on the server yet.",
  "En iPhone y iPad, las notificaciones funcionan con la app instalada: instálala y ábrela desde la pantalla de inicio.": "On iPhone and iPad, notifications work with the installed app: install it and open it from the Home Screen.",
  "Las notificaciones están bloqueadas para este sitio. Permítelas en la configuración del navegador (o del teléfono) y vuelve aquí.": "Notifications are blocked for this site. Allow them in your browser (or phone) settings and come back here.",
  "No se pudieron activar las notificaciones en este dispositivo.": "Couldn’t turn on notifications on this device.",
  "Notificaciones activadas en este dispositivo.": "Notifications are on for this device.",
  "Notificación enviada. Debe llegar en unos segundos; si no aparece, revisa que el teléfono o la computadora permitan las notificaciones del navegador (en Mac: Configuración del Sistema → Notificaciones → Google Chrome).": "Notification sent. It should arrive in a few seconds; if it doesn’t show up, check that your phone or computer allows notifications from the browser (on a Mac: System Settings → Notifications → Google Chrome).",
  "No se pudo enviar la notificación de prueba.": "Couldn’t send the test notification.",
  "Este dispositivo": "This device",
  "App": "App",
  "Estás usando la app instalada.": "You’re using the installed app.",
  "Instálala para abrirla desde la pantalla de inicio, como cualquier app.": "Install it to open it from your home screen, like any other app.",
  "Instalar la app": "Install the app",
  "Avisos de tu programación, inscripciones, grupos y mensajes, aunque la app esté cerrada.": "Notifications about your schedule, registrations, groups and messages, even when the app is closed.",
  "Activar notificaciones": "Turn on notifications",
  "Activadas": "On",
  "Enviar una prueba": "Send a test",
  "Mis dispositivos con notificaciones": "My devices with notifications",
  "Dispositivo": "Device",
  "este": "this one",
  "último aviso {when}": "last notification {when}",
  "activado {when}": "turned on {when}",
  "Instala la app en tu teléfono y recibe los avisos de la iglesia al instante.": "Install the app on your phone and get church notifications instantly.",
  "Activa las notificaciones para recibir los avisos de la iglesia al instante.": "Turn on notifications to get church notifications instantly.",
  "Ver cómo": "Show me how",
  "Cerrar aviso": "Close notice",
} satisfies Record<string, string>;
